export const ApiConfig = {
    apiEndpoint:  process.env.API_ENDPOINT || '/api',
    clientApiEndpoint: process.env.CLIENT_API_ENDPOINT || '/api',
};
